<template>
  <app-layout>
    <bax-header-banner-wide :user="this.$store.state.auth.user" :orderStep="stage" />
    <div class="bax-main-wrapper">
      <div class="bax-csv-processing" v-if="waitingReason">
        <img class="loading_animation" src="@/assets/images/loading.gif" alt="Loading" /> Please wait : {{ waitingReason }}

        <div class="loading_progress" :style="{backgroundSize : backgroundSizeX + 'px 36px'}">
          &nbsp;
        </div>
      </div>

      <div  v-show="!waitingReason" >
        <div v-if="stage === 1">
          <stage-1 @upload_code_set="onUploadCodeSet" @go_defaults="setStage('defaults');" @waiting_set="onWaitingSet"/>
        </div>
        <div v-else-if="stage === 2">
          <stage-2 :uploadCode="uploadCode" @progress="onProgress" @file_loaded="onFileLoaded" @waiting_set="onWaitingSet"/>
        </div>
        <div v-else-if="stage === 3">
          <stage-3 :uploadCode="uploadCode" @progress="onProgress" @cancel_upload="onCancelUpload" @rows_selected="onRowsSelected" @waiting_set="onWaitingSet"/>
        </div>
        <div v-else-if="stage === 4">
          <stage-4 :uploadCode="uploadCode" @progress="onProgress" @cancel_upload="onCancelUpload" @fields_matched="onFieldsMatched" @waiting_set="onWaitingSet"/>
        </div>
        <div v-else-if="stage === 5">
          <stage-5 :uploadCode="uploadCode" @progress="onProgress" @cancel_upload="onCancelUpload" @waiting_set="onWaitingSet"/>
        </div>
        <div v-else-if="stage === 'defaults'">
          <defaults  @goBack="setStage(1);" />
        </div>
      </div>
      </div>
  </app-layout>
</template>


<script>
  // import axios from 'axios';
  import CsvService from '@/core/api/csv/csv.service3';
  import Stage1 from '@/views/CsvUpload/stage1.vue';
  import Stage2 from '@/views/CsvUpload/stage2.vue';
  import Stage3 from '@/views/CsvUpload/stage3.vue';
  import Stage4 from '@/views/CsvUpload/stage4.vue';
  import Stage5 from '@/views/CsvUpload/stage5.vue';
  import Defaults from '@/views/CsvUpload/defaults.vue';
  import AppLayout from '@/components/layout/AppLayout.vue';
  import BaxHeaderBannerWide from '@/components/layout/BaxHeaderBannerWide.vue';

  export default {
    name: 'CsvImport',
    components: {
      Stage1,
      Stage2,
      Stage3,
      Stage4,
      Stage5,
      Defaults,
      AppLayout,
      BaxHeaderBannerWide,
    },
    data() {
      return {
        stage: 0,
        uploadCode: false,
        waitingReason: false,
        backgroundSizeX: 0,
        orderStatus: '',
      };
    },
    computed: {
    },
    created() {
      this.getPreviousRecords();
    },
    methods: {
      onProgress(progressPercent) {
        this.backgroundSizeX = (progressPercent * 6.36);
      },
      onUploadCodeSet(uploadCode) {
        this.uploadCode = uploadCode;
        this.setStage(2);
      },
      onCancelUpload() {
        this.setStage(1);
      },
      onFileLoaded() {
        this.setStage(3);
      },
      onRowsSelected() {
        this.setStage(4);
      },
      onFieldsMatched() {
        this.setStage(5);
      },
      setStage(stage) {
        this.stage = stage;
      },
      onWaitingSet(reason) {
        this.waitingReason = reason;
      },
      getPreviousRecords() {
        CsvService.fetchProcessedRows()
            .then((res) => {
              this.uploadCode = res.data.uploadCode;
              this.orderStatus = res.data.status;
              if (this.uploadCode && this.orderStatus === 'processed') {
                this.stage = 5;
              } else {
                this.stage = 1;
              }
        });
      },
    },
  };
</script>
